import { faCreditCard } from '@fortawesome/pro-solid-svg-icons/faCreditCard';
import { faMoneyBill } from '@fortawesome/pro-solid-svg-icons/faMoneyBill';
import { faRepeat } from '@fortawesome/pro-solid-svg-icons/faRepeat';
import { faChartSimple } from '@fortawesome/pro-solid-svg-icons/faChartSimple';
import { ColourStateSolid } from '@ukpostbox/frontend-framework';
import { Renew } from '../Pages/Payment/Renew';
import { TopUp } from '../Pages/Payment/TopUp';
import Transactions from '../Pages/Payment/Transactions';
import PaymentDetails from '../Pages/Payment/PaymentDetails';
import { SuggestibleRouteInterface } from '../../_Global/Types/RouteTypes';

const PaymentRoutes: Array<SuggestibleRouteInterface> = [
	{
		title: 'Payment Details',
		path: '/manage-account/payment/details',
		icon: faCreditCard,
		element: <PaymentDetails />,
		colour: ColourStateSolid.Warning,
		group: 'Payment',
	},
	{
		title: 'Top-up',
		path: '/manage-account/payment/top-up',
		icon: faChartSimple,
		element: <TopUp />,
		colour: ColourStateSolid.Warning,
		group: 'Payment',
	},
	{
		title: 'Renew',
		path: '/manage-account/payment/renew',
		icon: faRepeat,
		element: <Renew />,
		colour: ColourStateSolid.Warning,
		group: 'Payment',
	},
	{
		title: 'Transactions',
		path: '/manage-account/payment/transactions',
		icon: faMoneyBill,
		element: <Transactions />,
		colour: ColourStateSolid.Warning,
		group: 'Payment',
	},
];

export { PaymentRoutes };
